import React, { useRef, useState } from 'react';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../../components/base/Dropdown/Dropdown';
import TransportDTO from '../../../dto/TransportDTO';

export function FilterForm(props) {
  const { control } = props;

  const DTO = new TransportDTO();
  const attributes = DTO.getAttributesByName();

  return (
    <Dropdown>
      <Dropdown.Toggle className="auto-reload-toogle">
        <Button variant="second">
          <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="select-options-wrapper auto-reload-options-wrapper"
        classNamePortal="portal-select-options auto-reload-options"
      >
        <div className="filter-form">
          <div className="filter-form-header">
            <div className="f3">Фильтры</div>
            <Icons customIcon className="file-download" width={24} height={24} icon="close" />
          </div>
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            hideSmallButtons
            showArrowIcon
            usePortal
            dtoObject={attributes.brand}
            withLabel
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            hideSmallButtons
            showArrowIcon
            usePortal
            withLabel
            dtoObject={attributes.model}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            hideSmallButtons
            showArrowIcon
            usePortal
            dtoObject={attributes.color}
            withLabel
            variant="material"
          />
          <div className="filter-form-footer">
            <Button variant="secondary">Сбросить всё</Button>
            <Button>Показать</Button>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
